export default "__VITE_ASSET__a0829d31__"